import React from 'react';

export default function DisabledScreenSharingIcon(props) {
    return (
        <svg width='28' height='29' viewBox='-4 -4 36 37' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='evenodd'
                d='M11.38 13.353a.824.824 0 0 1-.824.823h-2.32v8.236h11.529v-8.236h-2.321a.824.824 0 1 1 0-1.647h2.32c.869 0 1.58.672 1.643 1.525l.005.122v8.236c0 .868-.672 1.58-1.524 1.642l-.123.005H8.235c-.868 0-1.58-.672-1.642-1.524l-.005-.123v-8.236c0-.868.672-1.58 1.524-1.642l.123-.005h2.321c.455 0 .824.37.824.824zM14 5.118l3.792 3.792a.834.834 0 1 1-1.179 1.18L14.856 8.33v7.133a.856.856 0 1 1-1.712 0V8.33l-1.758 1.759a.833.833 0 1 1-1.179-1.179L14 5.118z'
                opacity='.198'
            />
        </svg>
    );
}
